import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppError } from './app-error.model';

@Injectable({
  providedIn: 'root'
})

/**
 * Central UI notification entry point for the error layer.
 *
 * Version 1 deliberately supports only temporary snackbars so components do not
 * decide ad hoc durations, positions, or visibility rules.
 */
export class NotificationFacadeService {
  constructor(private snackBar: MatSnackBar) {
  }

  /**
   * Shows a product-safe snackbar only when the error is marked for snackbar display.
   */
  showError(error: AppError): void {
    if (error.displayMode !== 'snackbar') {
      return;
    }

    this.snackBar.open(error.userMessage, undefined, {
      duration: this.getDuration(error),
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['app-snackbar', `app-snackbar-${error.severity}`]
    });
  }

  /**
   * Warning-level messages remain visible slightly longer because they often
   * communicate recoverable business outcomes rather than hard failures.
   */
  private getDuration(error: AppError): number {
    return error.severity === 'warning' ? 7000 : 5000;
  }
}